module.exports = __webpack_public_path__ + "img/blank.ca4f67d8.svg";